<template>
  <div class="p-pnt">
    <div class="l-container">
      <MenuNavigation class="hidden" />
      <router-view></router-view>
    </div>
  </div>
</template>

<script>
import _ from 'lodash'
import MenuNavigation from './MenuNavigation'

import mark_watched from '@/mixins/mark_watched'
import { BREADCRUMBS } from '@/store/modules/app/actions'
import { GET_MENU_BASIC_INFO } from '@/store/modules/menu/actions'

export default {
  name: 'MenuMainContainer',
  components: {
    MenuNavigation
  },
  mixins: [mark_watched],
  data() {
    return {
      menuBasicInfo: null
    }
  },
  created() {
  },
  mounted() {
    this.getMenuBasicInfo()
  },
  watch: {
  },
  computed: {

  },
  methods: {
    getMenuBasicInfo() {
      const { menuNo } = this.$route.params
      this.$store.dispatch(GET_MENU_BASIC_INFO, { menuNo }).then(
        (data) => {
          this.menuBasicInfo = data
          // update breadcrumbs
          const breadcrumbs = _.cloneDeep(this.$route.meta.breadcrumbs)
          if(breadcrumbs.length < 3) {
            // path未指定でパンくず遷移しない構造のため指定なし
            breadcrumbs.push({
              // path: `/public-stay/menus/${menuNo}`,
              path: ``,
              title: _.get(this.menuBasicInfo, 'menuNm', '')
            })
          }
          this.$store.dispatch(BREADCRUMBS, breadcrumbs)
        }
      )
    }
  }
}
</script>